import { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import toastr from 'toastr';
import rsf from '../../helpers/firebase';

const functions = getFunctions(rsf.app);

// Sotto questa larghezza l'immagine apparirà morbida sugli schermi retina:
// è la causa più comune delle "immagini sgranate" segnalate dagli operatori.
export const MIN_RECOMMENDED_WIDTH = 1200;

const readAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Could not read the file'));
    reader.readAsDataURL(file);
  });

// Serve solo all'avviso: un file illeggibile come immagine viene comunque
// rifiutato dalla allow-list MIME lato server, quindi qui non si solleva.
const readWidth = (dataUrl) =>
  new Promise((resolve) => {
    const image = new Image();
    image.onload = () => resolve(image.naturalWidth);
    image.onerror = () => resolve(0);
    image.src = dataUrl;
  });

const useLandingAssetUpload = (countryId) => {
  const [uploading, setUploading] = useState(false);

  // In sequenza, non in parallelo: il payload di una callable si ferma a 10MB
  // e base64 gonfia del 33%, quindi le immagini viaggiano una per volta.
  const upload = async (files, onUploaded) => {
    if (!countryId) {
      toastr.error('Select a country first.', 'Upload');
      return;
    }
    setUploading(true);
    const fn = httpsCallable(functions, 'landingAssetUpload');

    for (let index = 0; index < files.length; index += 1) {
      const file = files[index];
      try {
        // eslint-disable-next-line no-await-in-loop
        const image = await readAsDataUrl(file);
        // eslint-disable-next-line no-await-in-loop
        const width = await readWidth(image);
        // eslint-disable-next-line no-await-in-loop
        const { data } = await fn({ image, fileName: file.name, countryId });
        if (data.error) throw new Error(data.error.message);
        if (!data.data || !data.data.url) {
          throw new Error('Upload returned an invalid response.');
        }
        onUploaded({
          url: data.data.url,
          lowRes: width > 0 && width < MIN_RECOMMENDED_WIDTH,
        });
      } catch (error) {
        toastr.error(`${file.name}: ${error.message}`, 'Upload failed');
      }
    }

    setUploading(false);
  };

  return { uploading, upload };
};

export default useLandingAssetUpload;
